import React from 'react';
import { twMerge } from 'tailwind-merge';

import defaultCompanyCoverImage from 'assets/defaultCompanyCoverImage.svg';

interface WelcomeBannerProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
  variant: string;
}
export enum WelcomeBannerVariant {
  WELCOME = 'welcome',
  INTEGRATION = 'integration',
}

const WelcomeBanner = ({
  title,
  description,
  children,
  variant,
}: WelcomeBannerProps) => {
  const titleClassName = twMerge(
    `${variant === WelcomeBannerVariant.WELCOME ? 'prose-display-2' : ''}`,
    `${variant === WelcomeBannerVariant.INTEGRATION ? 'prose-title-h2' : ''}`
  );

  const descriptionClassName = twMerge(
    `${variant === WelcomeBannerVariant.WELCOME ? 'prose-body-med-reg ' : ''}`,
    `${variant === WelcomeBannerVariant.INTEGRATION ? 'prose-body-sm-reg' : ''}`
  );

  return (
    <div
      className="overflow-hidden rounded-2xl bg-kira-blue-300 bg-cover bg-center bg-no-repeat py-10"
      style={{ backgroundImage: `url(${defaultCompanyCoverImage})` }}
    >
      <div className="flex h-full flex-col items-center justify-center space-y-2 text-kira-slate-0">
        <div className={`${titleClassName} flex text-center`}>{title}</div>
        <div className={`${descriptionClassName} flex text-center`}>
          {description}
        </div>
        {children}
      </div>
    </div>
  );
};

export default WelcomeBanner;
